function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.991.82l-2.583 12.139h-3.125L16.868.819h3.123zM33.14 8.658L34.782 4.1l.947 4.56h-2.591zm3.485 4.301h2.89L36.994.819h-2.67c-.598 0-1.105.352-1.33.891l-4.686 11.249h3.279l.652-1.812h4.008l.377 1.812zM28.47 8.996c.012-3.204-4.41-3.381-4.38-4.812.01-.436.423-.899 1.326-1.017.448-.059 1.68-.105 3.082.543l.548-2.574a8.329 8.329 0 00-2.924-.538c-3.086 0-5.26 1.65-5.279 4.013-.02 1.747 1.551 2.722 2.736 3.303 1.216.595 1.625.976 1.62 1.51-.008.813-.97 1.173-1.868 1.186-1.572.026-2.484-.425-3.21-.766l-.567 2.66c.73.337 2.077.63 3.476.645 3.28 0 5.429-1.63 5.44-4.153zM15.528.82l-5.064 12.139H7.162L4.67 3.271c-.15-.597-.282-.815-.743-1.067-.75-.409-1.99-.793-3.082-1.031L.92.82h5.317c.678 0 1.287.452 1.441 1.237l1.315 7.026L12.244.82h3.284z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#visa_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.991.82l-2.583 12.139h-3.125L16.868.819h3.123zM33.14 8.658L34.782 4.1l.947 4.56h-2.591zm3.485 4.301h2.89L36.994.819h-2.67c-.598 0-1.105.352-1.33.891l-4.686 11.249h3.279l.652-1.812h4.008l.377 1.812zM28.47 8.996c.012-3.204-4.41-3.381-4.38-4.812.01-.436.423-.899 1.326-1.017.448-.059 1.68-.105 3.082.543l.548-2.574a8.329 8.329 0 00-2.924-.538c-3.086 0-5.26 1.65-5.279 4.013-.02 1.747 1.551 2.722 2.736 3.303 1.216.595 1.625.976 1.62 1.51-.008.813-.97 1.173-1.868 1.186-1.572.026-2.484-.425-3.21-.766l-.567 2.66c.73.337 2.077.63 3.476.645 3.28 0 5.429-1.63 5.44-4.153zM15.528.82l-5.064 12.139H7.162L4.67 3.271c-.15-.597-.282-.815-.743-1.067-.75-.409-1.99-.793-3.082-1.031L.92.82h5.317c.678 0 1.287.452 1.441 1.237l1.315 7.026L12.244.82h3.284z",
  fill: "currentColor"
}));

function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 14,
    viewBox: "0 0 40 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "visa_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 14
  }, _ref), _ref2);
}

export default SvgVisa;